import React from 'react';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { ListItem, Box, Button, Typography } from "@material-ui/core";
import bin from '../assets/icons/white-bin.png';
import Checkbox from '../checkbox';
import SortableHeader from '../common/header-sortable';
import PropTypes from 'prop-types';
import { MESSAGES_TYPE } from '../utils';
import { useTranslate } from 'react-admin';

const useStyles = makeStyles(theme => ({
    header: {
        display: 'flex',
        flexDirection: 'row',
        paddingLeft: 0,
        backgroundColor:  theme.palette.primary.main,
        color: theme.palette.common.white,
        marginTop: theme.spacing(1),
        height: 50
    },
    checkbox: {
        color: theme.palette.common.white
    },
    delete: {
        fontSize: 13,
        fontFamily: 'UniviaPro',
        fontWeight: 'normal',
        letterSpacing: '0.13px',
        lineHeight: '16.3px',
    }
}));

const StyledButton = withStyles(theme => ({
    root: {
        background: 'transparent',
        color: 'white',
        marginRight: theme.spacing(4),
    },
    label: {
        fontSize: 14,
        textTransform: 'capitalize',
        fontWeight: 'normal',
        marginLeft: theme.spacing(1)
    },
}))(Button);

function Index({ selectedItems, onDelete, onCheckAll, order, onChangeSortable, type, checkall, isDelete }) {
    const classes = useStyles();
    const translate = useTranslate();

    const confirmDelete = () => {
        const ids = selectedItems.map(item => item.id);
        onDelete(ids);
    }

    if (selectedItems.length !== 0)
        return (
            <Box mt={1} px={1} py={1} bgcolor='#56657f'>
                {
                    isDelete &&
                    <Checkbox className={classes.checkbox} checked={checkall} onClick={onCheckAll} />
                }
                <StyledButton
                    onClick={confirmDelete}
                    variant='text'
                    startIcon={<img alt='' src={bin} style={{ width: "20px", paddingRight: 5 }} />}
                    size='large'
                ><Typography className={classes.delete}>{translate(`pos.common.delete`)}</Typography></StyledButton>
            </Box>
        );
    else {
        if (type === MESSAGES_TYPE.SENT)
            return (
                <ListItem className={classes.header}>
                    <Box flex={0.5} px={1}>
                        {
                            isDelete &&
                            <Checkbox className={classes.checkbox} onClick={onCheckAll} />
                        }
                    </Box>
                    <Box flex={4}>
                        <SortableHeader title={translate(`pos.messages.subject`)} field='subject' order={order} setOrder={onChangeSortable} />
                    </Box>
                    <Box flex={3}>
                        <SortableHeader title={translate(`resources.messages.to`)} field='toOwners' order={order} setOrder={onChangeSortable} />
                    </Box>
                    <Box flex={1}>
                        <SortableHeader title={translate(`pos.common.confirm`)} field='confirm' order={order} setOrder={onChangeSortable} />
                    </Box>
                    <Box flex={1}>
                        <SortableHeader title={translate(`resources.messages.sent`)} field='createdAt' order={order} setOrder={onChangeSortable} />
                    </Box>
                    <Box flex={0.5} />
                </ListItem>
            );
        else if (type === MESSAGES_TYPE.DRAFT)
            return (
                <ListItem className={classes.header}>
                    <Box flex={0.5} px={1}>
                        {
                            isDelete &&
                            <Checkbox className={classes.checkbox} onClick={onCheckAll} />
                        }
                    </Box>
                    <Box flex={4}>
                        <SortableHeader title={translate(`pos.messages.subject`)} field='subject' order={order} setOrder={onChangeSortable} />
                    </Box>
                    <Box flex={1}>
                        <SortableHeader title={translate(`resources.messages.created`)} field='createdAt' order={order} setOrder={onChangeSortable} />
                    </Box>
                    <Box flex={1}>
                        <SortableHeader title={translate(`pos.messages.schedule`)} field='schedule' order={order} setOrder={onChangeSortable} />
                    </Box>
                    <Box flex={0.5} />
                </ListItem>
            );
        return (
            <ListItem className={classes.header}>
                <Box flex={0.5} px={1}>
                    {
                        isDelete &&
                        <Checkbox className={classes.checkbox} onClick={onCheckAll} />
                    }
                </Box>
                <Box flex={3}>
                    <SortableHeader title={translate(`pos.messages.subject`)} field='subject' order={order} setOrder={onChangeSortable} />
                </Box>
                <Box flex={1}>
                    <SortableHeader title={translate(`resources.messages.created`)} field='createdAt' order={order} setOrder={onChangeSortable} />
                </Box>
                <Box flex={1}>
                    <SortableHeader title={translate(`pos.messages.schedule`)} field='schedule' order={order} setOrder={onChangeSortable} />
                </Box>
                <Box flex={0.5} />
            </ListItem>
        );
    }
}

Index.propTypes = {
    selectedItems: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
    onDelete: PropTypes.func.isRequired,
    onCheckAll: PropTypes.func.isRequired,
    onChangeSortable: PropTypes.func.isRequired
};

export default Index;
